<template>
  <div>
    <div v-if="$route.path == '/daftar' || $route.path == '/login'">
      <router-view />
    </div>
    <div id="appx" v-else>
      <div class="navbar">
        <div class="title">
          Dashboard Pendaftaran PSPP
        </div>
      </div>

      <div class="notif" v-if="false">
        <!-- <div class="notif" v-if="jumlahTagihan > 0"> -->
        Anda memiliki 1 tagihan yang belum dibayarkan.
        <router-link to="/tagihan">Bayar sekarang</router-link>
      </div>

      <div class="content">
        <div class="sidebar">
          <div class="logo">
            <img src="https://pendaftaran.pspp-integrated.com/v2/assets/img/logo.png" width="120">
          </div>
          <p class="submenu">
            <!-- Menu -->
          </p>
          <div class="menu">
            <ul>
              <li @click="linkTo('/')" :class="{ active: $route.path == '/' }">
                <div>
                  <span class="material-symbols-outlined">
                    home
                  </span>
                  Home
                </div>
              </li>
              <li @click="linkTo('/pembayaran')" :class="{ active: $route.path == '/pembayaran' }" >
                <div>
                  <span class="material-symbols-outlined">
                    credit_card
                  </span>
                  Pembayaran
                </div>
              </li>
              <li @click="linkTo('/tagihan')" :class="{ active: $route.path == '/tagihan' }" v-if="false">
                <div>
                  <span class="material-symbols-outlined">
                    credit_card
                  </span>
                  Tagihan
                </div>
              </li>
              <li @click="linkTo('/profil')" :class="{ active: $route.path == '/profil' }">
                <div>
                  <span class="material-symbols-outlined">
                    account_circle
                  </span>
                  Profil
                </div>
              </li>
              <li @click="linkTo('/upload-berkas')" :class="{ active: $route.path == '/upload-berkas' }">
                <div>
                  <span class="material-symbols-outlined">
                    upload
                  </span>
                  Berkas
                </div>
              </li>
              <li @click="linkTo('/ujian')" :class="{ active: $route.path == '/ujian' }">
                <div>
                  <span class="material-symbols-outlined">
                    assignment_turned_in
                  </span>
                  Ujian Masuk
                </div>
              </li>
              <li @click="linkTo('/pengumuman')" :class="{ active: $route.path == '/pengumuman' }">
                <div>
                  <span class="material-symbols-outlined">
                    notifications
                  </span>
                  Hasil Seleksi
                </div>
              </li>
              <li 
              @click="linkTo('/kelas-internasional')" 
              :class="{ active: $route.path == '/kelas-internasional' }" 
              class="soft-pulse"
              v-if="this.$store.state.siswa.data.id_jurusan != 4">
                {{ }}
                <div>
                  <span class="material-symbols-outlined">
                    globe_asia
                  </span>
                  Kelas Internasional                  
                </div>
              </li>
            </ul>
          </div>

          <div class="menu logout">
            <ul>
              <li @click="logout()">
                <div>
                  <span class="material-symbols-outlined">
                    login
                  </span>
                  Logout
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="main">
          <router-view />
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { apiGet } from './api';

export default {
  data() {
    return {
      jumlahTagihan: -1,
      program: localStorage.getItem('x-program-kelas') ? localStorage.getItem('x-program-kelas') : null
    }
  },
  methods: {
    linkTo(url) {
      if (url == this.$route.path) {
        return;
      }
      setTimeout(() => {
        this.$router.push(url);
      }, 150);
    },
    async loadTagihan() {
      try {
        const rProfil = await apiGet(`/v1/profil`, {
          headers: { Authorization: `Bearer ${this.$store.state.siswa.data.access_token}` },
        })
        this.program = rProfil.data.program;
        localStorage.setItem('x-program-kelas', this.program)

        const r = await apiGet(`/v1/tagihan`, {
          headers: { Authorization: `Bearer ${this.$store.state.siswa.data.access_token}` },
        });

        if (r.valid) {
          this.jumlahTagihan = r.data.filter((k) => k.status.toLowerCase() == 'pending').length
        }
      } catch (e) {
        if (e.response.status) {
          this.$router.push('/login')
        }
      }
    },
    logout() {
      localStorage.clear();
      location.reload();
    }
  },
  mounted() {
    if (this.$route.path != '/daftar' && location.hash != '#/login') {
      this.loadTagihan();
    }
  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Rubik:wght@400;500&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,300,0,0');

:root {
  --primary-disabled: #79c3ff;
  --primary: #1D82F9;
  --primary-darker: #1a87e0;
}

html,
body {
  margin: 0;
}

* {
  font-family: 'Rubik', sans-serif;
  -webkit-tap-highlight-color: transparent;
}

#appx {
  // max-width: 550px;
  margin: 0 auto;
  background: #FAFAFA;

  @media screen and (min-width: 768px) {
    // max-width: 1100px;
    min-height: 100vh;
    margin: 0 auto;
    overflow-y: auto;
    // box-shadow: 0px 0px 15px #ccc;
  }
}

h1,
h3 {
  font-weight: 500;
}

input,
select,
textarea {
  background: #fff;
  border: 1px solid #ccc;
  padding: 10px;
  outline: none;
  border-radius: 6px;
  width: 100%;
  transition: all .3s ease;
  font-size: 14px;

  &:focus {
    background: #fff;
    border: 1px solid var(--primary);
  }
}

textarea {
  width: calc(100% - 22px);
}

.btn {
  background: #eee;
  border: 1px solid #eee;
  border-radius: 6px;
  outline: none;
  padding: 8px 16px;
  transition: all 0.3s ease;
  cursor: pointer;
  font-size: 14px;

  &.btn-primary {
    background-color: var(--primary);
    border-color: var(--primary);
    color: #fff;

    &:disabled {
      background-color: var(--primary-disabled);
      border-color: var(--primary-disabled);
    }
  }

  &:active {
    transform: scale(0.95);
  }

  &.btn-outline {
    background-color: #fff;
    border-color: var(--primary);
    color: var(--primary);
  }

  &.btn-block {
    width: 100%;
  }
}

.form-group {
  margin-bottom: 15px;

  label {
    display: block;
    margin-bottom: 4px;
    font-size: 14px;
  }

  input {
    padding: 12px;
    width: calc(100% - 26px);
  }
}

.checkbox {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;

  input {
    width: auto;
  }
}

.btn-group {
  display: flex;
  justify-content: space-between;

  .btn {
    min-width: 120px;
  }
}

.fade-up {
  opacity: 0;
  animation: fadeUp 0.3s ease-in-out forwards;
}

@keyframes fadeUp {
  0% {
    opacity: 0;
    transform: translateY(60px);
  }

  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.navbar {
  border-bottom: 1px solid #ddd;
  background: #fff;
  padding: 20px;
  position: sticky;
  top: 0;
  font-weight: 500;
  gap: 10px;
  z-index: 9;

  .title {
    max-width: 900px;
    margin: 0 auto;
  }
}

.notif {
  max-width: calc(900px - 40px);
  margin: 20px auto;
  font-size: 14px;
  padding: 15px;
  border-radius: 5px;
  background: #FDF3F6;
  border: 1px solid #d91d1d;
  color: #d91d1d;

  a {
    color: #d91d1d;
    font-weight: 500;
  }
}

.content {
  display: grid;
  grid-template-columns: 200px 1fr;
  gap: 30px;
  padding: 20px;
  max-width: 900px;
  margin: 20px auto;

  @media screen and (max-width: 768px) {
    display: block;
    margin: 0;
    padding: 0;

    .sidebar {
      display: none;
    }
  }

  p.submenu {
    margin-top: 30px;
    text-align: left;
    color: #333;
    font-weight: 600;
  }

  .menu {
    padding: 10px 0;
    border-radius: 10px;
    position: sticky;
    top: 30px;

    &.logout {
      margin-top: 30px;
    }

    ul {
      list-style: none;
      padding: 0;
      margin: 0;

      li {
        display: flex;
        justify-content: space-between;
        align-items: center;
        text-decoration: none;
        color: #333;
        padding: 10px;
        transition: all 0.3s ease;
        cursor: pointer;
        font-size: 14px;
        border-radius: 6px;
        margin-bottom: 4px;

        &.active {
          background: #dfefff;
          font-weight: 500;
        }

        >div {
          display: flex;
          align-items: center;
          gap: 5px;
        }

        &:active {
          transform: scale(0.97);
        }

        &:last-child {
          border: 0;
        }

        &:hover {
          background-color: #dfefff;
        }
      }
    }
  }

  .title {
    margin-bottom: 20px;

    h3 {
      margin: 0;
    }
  }
}

.spinner {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 5px solid;
  border-color: #d6eafd;
  border-right-color: var(--primary);
  animation: spinner-d3wgkg 1s infinite linear;
  margin: 100px auto;
}

@keyframes spinner-d3wgkg {
  to {
    transform: rotate(1turn);
  }
}

@keyframes softPulse {

  0%,
  100% {
    opacity: 1;
    transform: scale(1);
  }

  50% {
    opacity: 0.8;
    transform: scale(1.05);
    color: #3b82f6;
  }
}

.soft-pulse {
  animation: softPulse 1.5s ease-in-out 3;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba($color: #000000, $alpha: 0.5);
  z-index: 9;
  display: flex;
  justify-content: center;
  align-items: flex-start;

  .modal-body {
    margin-top: 100px;
    background: #fff;
    padding: 20px;
    border-radius: 6px;
  }
}
</style>
